import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-basis-modal__container" }
const _hoisted_2 = { class: "row1 base-info__container" }
const _hoisted_3 = { class: "base-info__item" }
const _hoisted_4 = { class: "base-info__item--label" }
const _hoisted_5 = { class: "base-info__item--value" }
const _hoisted_6 = { class: "base-info__item" }
const _hoisted_7 = { class: "base-info__item--label" }
const _hoisted_8 = { class: "base-info__item--value" }
const _hoisted_9 = { class: "base-info__item" }
const _hoisted_10 = { class: "base-info__item--label" }
const _hoisted_11 = { class: "base-info__item--value" }
const _hoisted_12 = { class: "base-info__item" }
const _hoisted_13 = { class: "base-info__item--label" }
const _hoisted_14 = { class: "base-info__item--value" }
const _hoisted_15 = { class: "base-info__item" }
const _hoisted_16 = { class: "base-info__item--label" }
const _hoisted_17 = { class: "base-info__item--value" }
const _hoisted_18 = { class: "base-info__item" }
const _hoisted_19 = { class: "base-info__item--label" }
const _hoisted_20 = { class: "base-info__item--value" }
const _hoisted_21 = { class: "row2" }
const _hoisted_22 = { class: "graph__container" }
const _hoisted_23 = { class: "next-info__container" }
const _hoisted_24 = { class: "row3 past-info__container" }

import { equalYearMonthInfo } from '@/appLogic/interfaces/date';
import { changeDayChart } from '@/appLogic/view/orderChart';
import Chart from '@/components/atom/Chart.vue';
import { diContainer } from '@/coreContainer/container';
import { Order } from '@/coreDomainsModule/entities/order';
import { IOrderBasis, IOrderBasisNextMonthlyData } from '@/coreDomainsModule/entities/orderBasis';
import { AnnounceFactory } from '@/coreDomainsModule/factories/announceFactory';
import { ArrivalFactory } from '@/coreDomainsModule/factories/ArrivalFactory';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { convertLeadTimeByUnit } from '@/coreDomainsModule/leadtime';
import { DateService } from '@/coreDomainsModule/services/dateService';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { i18n } from '@/i18n';
import { computed, ref, watchEffect } from 'vue';

const TABLE_NUM_CELL_WIDTH = 105;
const CHART_PERIOD = 180;

interface Props {
  modalState?: boolean;
  orderData?: Order;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderBasisInfoModal',
  props: {
    modalState: { type: Boolean, default: false },
    orderData: { default: undefined }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "995f8158": (`${140 + TABLE_NUM_CELL_WIDTH * 3}px`)
}))

const t = i18n.t;

const NextMonthlyTableGridTemplateColumn = ['140px', ...new Array(6).fill(`${TABLE_NUM_CELL_WIDTH}px`)];
const PastMonthlyTableGridTemplateColumn = ['66px', ...new Array(12).fill(`${TABLE_NUM_CELL_WIDTH}px`)];

/**
 * コンポーネントのProps定義
 */
const props = __props;

const emits = __emit;

const basisData = ref<IOrderBasis | undefined>(undefined);
const chartData = ref<any>(undefined);

/**
 * 以後月一覧
 */
const nextMonthlyDates = computed(() => {
  if (!basisData.value || basisData.value.nextMonthlyInfos.length === 0) return [];
  const startYearMonth = basisData.value.nextMonthlyInfos.reduce((acc, current) =>
    DateService.compareYearMonths(acc.orderBasisTargetYearMonth, current.orderBasisTargetYearMonth) === 1 ? current : acc
  ).orderBasisTargetYearMonth;
  return Array.from({ length: 6 }, (_, i) => DateService.getShiftedIYearMonthByMonths(startYearMonth.year, startYearMonth.month, i));
});

/**
 * 以後月次データ
 */
const nextMonthlyInfo = computed(() => {
  return nextMonthlyDates.value.map((month) =>
    basisData.value?.nextMonthlyInfos.find((pmi) => equalYearMonthInfo(pmi.orderBasisTargetYearMonth, month))
  );
});

/**
 * 以前月一覧
 */
const pastMonthlyDates = computed(() => {
  if (!basisData.value || basisData.value.pastMonthlyInfos.length === 0) return [];
  const endYearMonth = basisData.value.pastMonthlyInfos.reduce((acc, current) =>
    DateService.compareYearMonths(acc.orderBasisTargetYearMonth, current.orderBasisTargetYearMonth) === 1 ? acc : current
  ).orderBasisTargetYearMonth;
  return Array.from({ length: 12 }, (_, i) => DateService.getShiftedIYearMonthByMonths(endYearMonth.year, endYearMonth.month, -11 + i));
});

/**
 * 以前月次データ
 */
const pastMonthlyInfo = computed(() => {
  return pastMonthlyDates.value.map((month) =>
    basisData.value?.pastMonthlyInfos.find((pmi) => equalYearMonthInfo(pmi.orderBasisTargetYearMonth, month))
  );
});

/**
 * エラーモーダルを表示する
 */
const showErrorModal = async () => {
  await showInfoModal({
    modalTitle: t('エラーが発生しました。'),
    modalDescription: t('発注根拠の取得に失敗しました。'),
    isDisabledNextButton: true,
    backButtonLabel: t('OK'),
    colorStyle: 'error',
    icon: 'error',
  });
  closeModal();
};

/**
 * 予入荷を計算して返す
 * @param nextMonthlyData - 以後月次データ
 */
const calcPreArrivalAmount = (nextMonthlyData: IOrderBasisNextMonthlyData | undefined) => {
  if (!nextMonthlyData) return '--';
  return nextMonthlyData.dailyInfos.reduce((acc, dailyInfo) => (acc += dailyInfo.snapshotArrivalAmount), 0).addComma();
};

/**
 * このモーダルを閉じる
 */
const closeModal = () => {
  emits('close');
};

watchEffect(async () => {
  // データがない場合はスキップ
  if (!props.modalState || !props.orderData) {
    basisData.value = undefined;
    chartData.value = undefined;
    return;
  }
  const orderBasisId = props.orderData.orderBasisId;
  if (!orderBasisId) {
    await showErrorModal();
    return;
  }
  // 発注根拠情報取得
  const result = await waitLoading(diContainer.getOrderBasisUseCase.execute(orderBasisId));
  if (!result || result.status.type === 'error') {
    await showErrorModal();
    return;
  }
  basisData.value = result.status.data;

  // チャート描画
  // 登録済みの入荷snapshotをIArrivalに置き換える
  const expandedArrivalInfos = basisData.value.nextMonthlyInfos.flatMap((nextMonthlyInfo) =>
    nextMonthlyInfo.dailyInfos.map((nextDailyInfo) =>
      ArrivalFactory.create({
        amount: nextDailyInfo.snapshotArrivalAmount,
        crossDate: { ...nextMonthlyInfo.orderBasisTargetYearMonth, day: nextDailyInfo.orderBasisTargetDay },
        isFixOrdered: true,
      })
    )
  );
  // 最も納期が後ろの発注済み予入荷を持っておく
  const lastExpandedArrivalInfo = expandedArrivalInfos
    .sort((a, b) => {
      if (!a.crossDate) return -1;
      if (!b.crossDate) return 1;
      return DateService.compareDates(a.crossDate, b.crossDate);
    })
    .at(-1);
  // Chart用のIBusinessを組み立てる
  const graphBusiness = BusinessFactory.create({
    package: basisData.value.snapshotPackage.toString(),
    inventory: basisData.value.snapshotLatestInventoryAmount,
    executionDate: new Date(basisData.value.snapshotExecutionDate),
    MOQ: basisData.value.snapshotMoq,
    customerAnnounceDaily: basisData.value.customerAnnounceDaily ?? [],
    customerAnnounce: basisData.value.nextMonthlyInfos
      .map((info) =>
        AnnounceFactory.create({
          year: info.orderBasisTargetYearMonth.year,
          month: info.orderBasisTargetYearMonth.month,
          amount: info.snapshotCustomerForecastAmount,
        })
      )
      .concat(
        basisData.value.pastMonthlyInfos.map((info) =>
          AnnounceFactory.create({
            year: info.orderBasisTargetYearMonth.year,
            month: info.orderBasisTargetYearMonth.month,
            amount: info.snapshotCustomerForecastAmount,
          })
        )
      ),
    stdInventoryIndices: { 標準在庫指数: basisData.value.userAdjustedStdInventoryIndex },
    recommend: expandedArrivalInfos,
  });
  // Chart用のExtraSimulateを組み立てる
  const graphExtraSimulate = {
    extraAnnounce: basisData.value.nextMonthlyInfos
      .map((info) =>
        AnnounceFactory.create({
          year: info.orderBasisTargetYearMonth.year,
          month: info.orderBasisTargetYearMonth.month,
          amount: info.userAdjustedCustomerForecastAmount,
        })
      )
      .concat(
        basisData.value.pastMonthlyInfos.map((info) =>
          AnnounceFactory.create({
            year: info.orderBasisTargetYearMonth.year,
            month: info.orderBasisTargetYearMonth.month,
            amount: info.snapshotCustomerForecastAmount,
          })
        )
      ),
    extraStartDate: lastExpandedArrivalInfo?.crossDate
      ? new Date(
          DateService.convertIDateToUnixTime(
            DateService.getShiftedIYearMonthByDays(
              lastExpandedArrivalInfo.crossDate.year,
              lastExpandedArrivalInfo.crossDate.month,
              lastExpandedArrivalInfo.crossDate.day,
              1
            )
          )
        )
      : new Date(basisData.value.snapshotExecutionDate),
    extraLeadTime: basisData.value.userAdjustedLeadTime.value,
    extraStdInventory: basisData.value.userAdjustedStdInventoryIndex,
    extraRecommend: expandedArrivalInfos,
  };
  // Chart用にシュミレートを回す
  chartData.value = await changeDayChart(
    graphBusiness,
    null,
    CHART_PERIOD,
    0,
    DateService.convertDateToIDate(new Date(basisData.value.snapshotExecutionDate)),
    graphExtraSimulate
  );
});

/**
 * 単位付きの値をi18nで変換する
 * @param value - 値
 * @param unit - 単位
 * @param needConvert - 値を単位に合わせて変換する必要があるか
 */
const convertNumberWithUnitToStringWithGuard = (value?: number, unit?: string, needConvert = false): string => {
  if (!value || !unit) return '--';
  const convertedValue = needConvert ? convertLeadTimeByUnit(value, unit) : value;
  if (['month', 'months'].includes(unit)) {
    return convertedValue + t('発注根拠モーダル:月');
  } else if (['week', 'weeks'].includes(unit)) {
    return convertedValue + t('発注根拠モーダル:週');
  } else if (['day', 'days'].includes(unit)) {
    return convertedValue + t('発注根拠モーダル:日');
  }
  return convertedValue.toString();
};

/**
 * undefinedガード付きのunixTime変換関数
 * @param date - unixTimeの日付情報(undefined許容)
 */
const convertToDisplayUnixTimeWithGuard = (date?: number) =>
  date ? DateService.convertIYearMonthDayToYYYYMMDDWithSlash(DateService.convertUnixTimeToIDate(date / 1000)) : '--';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState && !!_ctx.orderData && !!basisData.value,
    "back-button-label": _unref(t)('閉じる'),
    "modal-width": 1390,
    "is-disabled-next-button": "",
    "enable-outside-click": "",
    "no-description": "",
    onOnBack: closeModal
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('発注根拠詳細')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('発注作成日')), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(convertToDisplayUnixTimeWithGuard(_ctx.orderData?.createdOrderDate)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('発注数量')), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.orderData?.initialOrderAmount?.addComma() ?? '--'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('希望納期')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(convertToDisplayUnixTimeWithGuard(_ctx.orderData?.initialDesiredDeliveryDate)), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('標準在庫指数(min)')), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(convertNumberWithUnitToStringWithGuard(
                basisData.value?.userAdjustedStdInventoryIndex.min,
                basisData.value?.userAdjustedStdInventoryIndex.option.unit
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('標準在庫指数(max)')), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(convertNumberWithUnitToStringWithGuard(
                basisData.value?.userAdjustedStdInventoryIndex.max,
                basisData.value?.userAdjustedStdInventoryIndex.option.unit
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('リードタイム')), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(convertNumberWithUnitToStringWithGuard(basisData.value?.userAdjustedLeadTime.value, basisData.value?.userAdjustedLeadTime.unit, true)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(Chart, {
              "date-unit": 'day',
              width: 900,
              height: 400,
              styles: {
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
            },
              "chart-data": chartData.value
            }, null, 8, ["chart-data"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(EzTable, {
              class: "table",
              "grid-template-columns": NextMonthlyTableGridTemplateColumn,
              "sticky-header": "",
              "sticky-left-columns": ""
            }, {
              header: _withCtx(() => [
                _createVNode(EzHeader, { class: "table--header table--left-header" }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyDates.value, (header, index) => {
                  return (_openBlock(), _createBlock(EzHeader, {
                    key: index,
                    class: "table--header"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(DateService).convertIYearMonthToYYYYMMWithSlash(header, true)), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              body: _withCtx(() => [
                _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
                  default: _withCtx(() => [
                    _createVNode(EzCell, {
                      class: "table--cell table--left-header",
                      "content-padding": 8
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('予入荷')), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                      return (_openBlock(), _createBlock(EzCell, {
                        key: index,
                        class: "table--cell",
                        "is-number": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(calcPreArrivalAmount(targetMonthBasis)), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024))
                    }), 128))
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
                  default: _withCtx(() => [
                    _createVNode(EzCell, {
                      class: "table--cell table--left-header",
                      "content-padding": 8
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('オリジナル内示')), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                      return (_openBlock(), _createBlock(EzCell, {
                        key: index,
                        class: "table--cell",
                        "is-number": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotCustomerForecastAmount.addComma() ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024))
                    }), 128))
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
                  default: _withCtx(() => [
                    _createVNode(EzCell, {
                      class: "table--cell table--left-header",
                      "content-padding": 8
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('シミュレーション内示')), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                      return (_openBlock(), _createBlock(EzCell, {
                        key: index,
                        class: "table--cell",
                        "is-number": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(targetMonthBasis?.userAdjustedCustomerForecastAmount.addComma() ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024))
                    }), 128))
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
                  default: _withCtx(() => [
                    _createVNode(EzCell, {
                      class: "table--cell table--left-header",
                      "content-padding": 8
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('予末在庫')), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                      return (_openBlock(), _createBlock(EzCell, {
                        key: index,
                        class: "table--cell",
                        "is-number": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotPreInventoryAmount.addComma() ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024))
                    }), 128))
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzTableRow, { "grid-template-columns": NextMonthlyTableGridTemplateColumn }, {
                  default: _withCtx(() => [
                    _createVNode(EzCell, {
                      class: "table--cell table--left-header",
                      "content-padding": 8
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('在庫回転率')), 1)
                      ], undefined, true),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextMonthlyInfo.value, (targetMonthBasis, index) => {
                      return (_openBlock(), _createBlock(EzCell, {
                        key: index,
                        class: "table--cell",
                        "force-right": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(targetMonthBasis && targetMonthBasis.snapshotCustomerForecastAmount !== 0
                        ? (targetMonthBasis.snapshotPreInventoryAmount / targetMonthBasis.snapshotCustomerForecastAmount).roundToDecimal(2)
                        : '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024))
                    }), 128))
                  ], undefined, true),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(EzTable, {
            class: "table",
            "grid-template-columns": PastMonthlyTableGridTemplateColumn,
            "sticky-header": ""
          }, {
            header: _withCtx(() => [
              _createVNode(EzHeader, { class: "table--header" }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyDates.value, (header, index) => {
                return (_openBlock(), _createBlock(EzHeader, {
                  key: index,
                  class: "table--header"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(DateService).convertIYearMonthToYYYYMMWithSlash(header, true)), 1)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            body: _withCtx(() => [
              _createVNode(EzTableRow, { "grid-template-columns": PastMonthlyTableGridTemplateColumn }, {
                default: _withCtx(() => [
                  _createVNode(EzCell, {
                    class: "table--cell",
                    "content-padding": 8
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('販売実績')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyInfo.value, (targetMonthBasis, index) => {
                    return (_openBlock(), _createBlock(EzCell, {
                      key: index,
                      class: "table--cell",
                      "is-number": ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotSalesResultAmount.addComma() ?? '--'), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  }), 128))
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzTableRow, { "grid-template-columns": PastMonthlyTableGridTemplateColumn }, {
                default: _withCtx(() => [
                  _createVNode(EzCell, {
                    class: "table--cell",
                    "content-padding": 8
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('内示')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyInfo.value, (targetMonthBasis, index) => {
                    return (_openBlock(), _createBlock(EzCell, {
                      key: index,
                      class: "table--cell",
                      "is-number": ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(targetMonthBasis?.snapshotCustomerForecastAmount.addComma() ?? '--'), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  }), 128))
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzTableRow, { "grid-template-columns": PastMonthlyTableGridTemplateColumn }, {
                default: _withCtx(() => [
                  _createVNode(EzCell, {
                    class: "table--cell",
                    "content-padding": 8
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('正答率')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMonthlyInfo.value, (targetMonthBasis, index) => {
                    return (_openBlock(), _createBlock(EzCell, {
                      key: index,
                      class: "table--cell",
                      "force-right": ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(targetMonthBasis
                      ? (
                          (targetMonthBasis.snapshotSalesResultAmount / targetMonthBasis.snapshotCustomerForecastAmount) *
                          100
                        ).roundToDecimal(2) + '%'
                      : '--'), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  }), 128))
                ], undefined, true),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label"]))
}
}

})